export var RateTypeEnum;
(function (RateTypeEnum) {
    RateTypeEnum["FIXED"] = "fixed";
    RateTypeEnum["FLOAT"] = "float";
})(RateTypeEnum || (RateTypeEnum = {}));
//# sourceMappingURL=rate-type.enum.js.map